import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  font-family: "Poppins", sans-serif;

  h1 {
    /* text-transform: uppercase; */
    font-size: 1.5rem;
    font-weight: 400;
    margin: 0rem;
    color: var(--primary2);
  }
  span {
    font-size: 0.9rem;
  }

  h4,
  .div__data_and_address {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    margin: 1rem 0rem;
    font-size: 0.8rem;
    padding-bottom: 0.5rem;
    color: rgba(var(--black_rgb), 0.8);
    border-bottom: 1px dotted rgba(var(--black_rgb), 0.2);
    font-weight: 400;

    ::after {
      display: block;
      content: "";
      margin: 0.5rem 0rem;
      border-bottom: 1px dotted rgba(var(--black_rgb), 0.5);
    }
  }

  p {
    flex: 1;
    margin: 0rem;
    font-size: 0.9rem;
  }
  label {
    font-weight: 600;
  }
  .div__oneRow {
    display: flex;
  }
  .div__moreOptions {
    text-align: right;

    .btn__newDocument {
      font-size: 0.8rem;
      cursor: pointer;
      border: 1px solid var(--primary2);
      color: var(--primary2);
      background-color: transparent;
      border-radius: var(--border-radius);
      padding: 0.3rem 0.7rem;
      margin: 0rem 1rem;

      :hover {
        box-shadow: 0px 0px 10px rgba(var(--black_rgb), 0.3);
      }
    }
  }

  input,
  select {
    outline-color: var(--primary2);
    padding: 0.75rem 0.5rem;
    border: 1px solid rgba(var(--black_rgb), 0.3);

    margin: 0.5rem 0.25rem;
    width: 100%;
    z-index: 0;
  }

  .div__moreFiles {
    text-align: right;

    .btn__newFile {
      font-family: "Poppins", sans-serif;
      text-transform: uppercase;

      padding: 0.5rem 1rem;
      background-color: var(--primary2);
      border: 0px;
      border-radius: var(--border-radius);
      color: var(--white);
      margin-bottom: 0.5rem;
      /* margin-bottom: 0.75rem; */
      cursor: pointer;
      :hover,
      :focus {
        box-shadow: 0px 0px 10px rgba(var(--black_rgb), 0.4);
        /* filter: brightness(1.4); */
      }
    }
    .btn__cancel {
      font-family: "Poppins", sans-serif;
      text-transform: uppercase;

      padding: 0.5rem 1rem;
      background-color: transparent;
      border: 1px solid var(--primary2);
      border-radius: var(--border-radius);
      color: var(--primary2);
      margin-right: 0.75rem;
      cursor: pointer;
      :hover,
      :focus {
        box-shadow: 0px 0px 20px rgba(var(--black_rgb), 0.2);
      }
    }
  }

  @media screen and (max-width: 675px) {
    .div__oneRow {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const FielButtons = styled.div`
  display: flex;
  /* background: red; */
  align-items: center;

  .btn__retornar {
    font-family: "Poppins", sans-serif;
    text-transform: uppercase;
    width: 100%;
    max-width: 180px;
    height: 35px;
    background-color: transparent;
    border: 1px solid var(--primary2);
    border-radius: var(--border-radius);
    color: var(--primary2);
    /* margin-top: 1rem; */
    margin-right: 0.75rem;
    cursor: pointer;
    :hover,
    :focus {
      box-shadow: 0px 0px 20px rgba(var(--black_rgb), 0.2);
    }
  }
  .btn__register {
    font-family: "Poppins", sans-serif;
    text-transform: uppercase;

    width: 320px;
    height: 35px;
    background-color: var(--primary2);
    border: 0px;
    border-radius: var(--border-radius);
    color: var(--white);
    /* margin-top: 1rem; */
    /* margin-bottom: 0.75rem; */
    cursor: pointer;
    :hover,
    :focus {
      box-shadow: 0px 0px 20px rgba(var(--black_rgb), 0.4);
      filter: brightness(1.4);
    }
  }

  @media screen and (max-width: 675px) {
    flex-direction: column-reverse;
    flex: 1;

    .btn__retornar,
    .btn__register {
      /* margin: auto; */
      width: 100% !important;
      max-width: none;
      margin: 0.5rem;
      font-size: 1rem;
    }
  }
`;
